package org.example.zone360.pages.dashboard.keywordUsage

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CommonDropdown
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.KeywordsUsageData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.pages.dashboard.SelectedBox
import org.example.zone360.pages.dashboard.clubKeywords.AddKeywords
import org.example.zone360.pages.dashboard.clubKeywords.DeleteKeywords
import org.example.zone360.pages.dashboard.clubKeywords.KeywordsWithoutCount
import org.example.zone360.pages.dashboard.clubKeywords.mapLanguageToCode
import org.example.zone360.theme.SitePalette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal.Companion.clubKeywordsList
import org.example.zone360.utils.Constants
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedKeywords
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.example.zone360.utils.getCurrentMilliseconds
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import kotlin.math.ln

@Composable
fun KeywordUsage(
    keywordResponse: List<KeywordsUsageData>,
    selectedLanguage: SelectedLanguage,
    toastMessage: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    var selectedKeywords by remember { mutableStateOf(SelectedKeywords.Detected) }
    var selectedCategory by remember { mutableStateOf("All Categories") }
    var selectedLanguages by remember { mutableStateOf("All Languages") }
    var addKeyword by remember { mutableStateOf(false) }
    var showPopup by remember { mutableStateOf(false) }
    var clubKeywordsButton by remember { mutableStateOf(false) }

    if (addKeyword) {
        AddKeywords(
            onDialogDismiss = { addKeyword = false },
            breakpoint = breakpoint,
            toastMessageCall = toastMessage
        )
    }

    if (showPopup) {
        DeleteKeywords(
            clubKeywords = clubKeywordsList.filter { !it.isDefault },
            onDismiss = { showPopup = false },
            breakpoint = breakpoint,
            toastMessage = toastMessage
        )
    }

    Column(
        modifier = Modifier.fillMaxWidth()
//            .width(
//                if (breakpoint > Breakpoint.LG) 68.percent
//                else if (breakpoint == Breakpoint.LG) 59.percent
//                else if (breakpoint >= Breakpoint.MD) 54.percent
//                else 100.percent
//            )
            .height(if (breakpoint <= Breakpoint.MD) 600.px else 300.px)
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(15.px)
            .padding(topBottom = 10.px, leftRight = 25.px)
    ) {
        // Filter row (unchanged)
        Row(
            modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap).gap(if (breakpoint < Breakpoint.MD) 10.px else 20.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            FieldTitleTextNormalSimple(
                text = "Keywords",
                fontSize = 18.px,
                fontWeight = 600,
                marginTop = if (window.screen.width <= 375) 10.px else 0.px
            )
            Row(
                modifier = Modifier.width(188.px)
                    .height(42.px)
                    .borderRadius(6.px)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .padding(leftRight = 5.px, topBottom = 4.px)
                    .border(1.px, LineStyle.Solid, Colors.LightGray),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SelectedBox(
                    text = "Detected",
                    breakpoint = breakpoint,
                    width = 87.px,
                    height = 34.px,
                    fontSize = 15.px,
                    fontWeight = 500,
                    isSelected = selectedKeywords == SelectedKeywords.Detected,
                    onClick = {
                        selectedKeywords = SelectedKeywords.Detected
                        clubKeywordsButton = false
                    }
                )
                SelectedBox(
                    text = "Full List",
                    breakpoint = breakpoint,
                    width = 87.px,
                    height = 34.px,
                    fontSize = 15.px,
                    fontWeight = 500,
                    isSelected = selectedKeywords == SelectedKeywords.FullList,
                    onClick = {
                        selectedKeywords = SelectedKeywords.FullList
                        clubKeywordsButton = true
                    }
                )
            }

            Box(modifier = Modifier.width(
                when {
                    breakpoint < Breakpoint.MD -> 100.percent
                    window.screen.width == 768 -> 30.percent
                    window.screen.width in 900..1400 -> 29.percent
                    window.screen.width in 1401..1600 -> 18.percent
                    else -> 15.percent
                }
            )) {
                CommonDropdown(
                    height = 42.px,
                    data = Strings.CATEGORY_LIST_FOR_KEYWORDS,
                    onSelect = { selectedCategory = it },
                    selectedItem = selectedCategory,
                    width = 100.percent,
                )
            }
            Box(
                modifier = Modifier
                    .width(
                    when {
                        breakpoint < Breakpoint.MD -> 100.percent
                        window.screen.width == 768 -> 30.percent
                        window.screen.width in 900..1400 -> 29.percent
                        window.screen.width in 1401..1600 -> 18.percent
                        else -> 15.percent
                    }
                )
            ) {
                CommonDropdown(
                    height = 42.px,
                    data = Strings.LANGUAGES_LIST,
                    onSelect = { selectedLanguages = it },
                    selectedItem = selectedLanguages,
                    width = 100.percent,
                )
            }
            if (breakpoint > Breakpoint.MD) Spacer()
            Row(
                modifier = Modifier.width(
                    when {
                        breakpoint <= Breakpoint.MD -> 100.percent
                        window.screen.width == 1440 -> 36.percent
                        window.screen.width == 1024 -> 35.percent
                        else -> 33.percent
                    }
                )
                    .gap(if (window.screen.width == 1440) 10.px else 10.px)
                    .flexWrap(FlexWrap.Wrap)
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 10.px else 0.px),
                horizontalArrangement = if (breakpoint <= Breakpoint.MD) Arrangement.Start else Arrangement.End
            ) {
                if (clubKeywordsButton) {
                    CommonButton(
                        text = "Delete Keywords",
                        icon = {
                            FaTrash(
                                size = IconSize.X1,
                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
                            )
                        },
                        width = if (breakpoint < Breakpoint.XL) 139.px else 150.px,
                        height = 40.px,
                        onCLick = { showPopup = true }
                    )
                    CommonButton(
                        text = "Add Keywords",
                        icon = {
                            FaPlus(
                                size = IconSize.X1,
                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb)
                            )
                        },
                        width = if (breakpoint < Breakpoint.MD) 130.px else 135.px,
                        height = 40.px,
                        onCLick = { addKeyword = true }
                    )
                }
            }
        }

        val languageCode = mapLanguageToCode(selectedLanguages)

        // --- Scrollable keyword area (fills remaining space) ---
        Box(
            modifier = Modifier
                .weight(1f)                     // take all remaining vertical space
                .fillMaxWidth()
                .padding(top = 12.px)           // optional spacing
                .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
        ) {
            if (selectedKeywords == SelectedKeywords.FullList) {
                val filteredClubList = clubKeywordsList.filter { keyword ->
                    (selectedCategory == "All Categories" ||
                            keyword.keywordCategory.equals(selectedCategory, ignoreCase = true)) &&
                            (selectedLanguages == "All Languages" ||
                                    keyword.language.equals(languageCode, ignoreCase = true))
                }
                // Wrap the list in a Row that allows wrapping and takes full width
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .flexWrap(FlexWrap.Wrap)
                        .padding(8.px)
                ) {
                    KeywordsWithoutCount(
                        response = filteredClubList,
                        selectedLanguage = selectedLanguage
                    )
                }
            } else {
                val filteredAllList = keywordResponse.filter { keyword ->
                    (selectedCategory == "All Categories" ||
                            keyword.keywordCategory.equals(selectedCategory, ignoreCase = true)) &&
                            (selectedLanguages == "All Languages" ||
                                    keyword.language.equals(languageCode, ignoreCase = true))
                }
                // Detected cloud – container height will be determined by the parent Box
                DetectedCloudContainer(
                    keywords = filteredAllList,
                    selectedLanguage = selectedLanguage,
                    sitePalette = sitePalette
                )
            }
        }
    }
}

//@Composable
//fun Keywords(
//    response: List<KeywordsUsageData>,
//    selectedLanguage: SelectedLanguage,
//) {
//    val sitePalette = ColorMode.current.toSitePalette()
//    val sortedData = response.sortedByDescending { it.usageCount }
//    sortedData.forEach { keywordData ->
//        val keywordText = keywordData.text
//        val count = keywordData.usageCount
//        val keywordCategory = keywordData.keywordCategory
//        Box {
//            Box(
//                modifier = Modifier.height(32.px)
//                    .backgroundColor(
//                        when (keywordCategory) {
//                            if (selectedLanguage == SelectedLanguage.English) "fitness" else "atletico" -> sitePalette.fitnessCategoryBackground.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "mental" else "mentale" -> sitePalette.mentalCategoryBackground.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "technical" else "tecnica" -> sitePalette.technicalCategoryBackground.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "tactical" else "tattica" -> sitePalette.tacticalCategoryBackground.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBackground.rgb
//                            else -> sitePalette.primary.rgb.copyf(alpha = 0.1f)
//                        }
//                    )
//                    .borderRadius(7.px)
//                    .padding(leftRight = 8.px, topBottom = 4.px)
//                    .border(
//                        1.px, color =
//                        when (keywordCategory) {
//                            if (selectedLanguage == SelectedLanguage.English) "fitness" else "atletico" -> sitePalette.fitnessCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "mental" else "mentale" -> sitePalette.mentalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "technical" else "tecnica" -> sitePalette.technicalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "tactical" else "tattica" -> sitePalette.tacticalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBorder.rgb
//                            else -> sitePalette.primary.rgb
//                        }, style = LineStyle.Solid
//                    )
//                    .margin(7.px),
//                contentAlignment = Alignment.Center
//            ) {
//                SpanText(
//                    keywordText,
//                    modifier = Modifier.fontFamily(Constants.FONT_FAMILY).fontSize(13.px)
//                )
//            }
//            Box(
//                modifier = Modifier.minSize(18.px)
//                    .margin(right = (-5).px)
//                    .align(Alignment.TopEnd)
//                    .backgroundColor(
//                        when (keywordCategory) {
//                            if (selectedLanguage == SelectedLanguage.English) "fitness" else "atletico" -> sitePalette.fitnessCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "mental" else "mentale" -> sitePalette.mentalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "technical" else "tecnica" -> sitePalette.technicalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "tactical" else "tattica" -> sitePalette.tacticalCategoryBorder.rgb
//                            if (selectedLanguage == SelectedLanguage.English) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBorder.rgb
//                            else -> sitePalette.primary.rgb
//                        }
//                    )
//                    .padding(leftRight = 2.px)
//                    .borderRadius(100.px),
//                contentAlignment = Alignment.Center
//            ) {
//                SpanText(
//                    "$count",
//                    modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
//                        .color(Colors.White)
//                        .fontSize(10.px)
//
//                )
//            }
//        }
//    }
//}
@Composable
fun DetectedCloudContainer(
    keywords: List<KeywordsUsageData>,
    selectedLanguage: SelectedLanguage,
    sitePalette: SitePalette
) {
    val isEnglish = selectedLanguage == SelectedLanguage.English
    val containerId = remember(keywords) { "cloud-container-${keywords.hashCode()}-${getCurrentMilliseconds()}" }

    // Container is scrollable; the SVG inside will be taller than the container if needed
    Box(
        modifier = Modifier
            .fillMaxSize()
            .overflow(overflowY = Overflow.Auto, overflowX = Overflow.Hidden)
    ) {
        Div(attrs = {
            id(containerId)
            style {
                property("width", "100%")
                property("height", "100%")
            }
        })

        LaunchedEffect(keywords) {
            val container = document.getElementById(containerId)
            if (keywords.isEmpty()) {
                container?.innerHTML = ""
            } else if (container != null && container.clientHeight > 0) {
                renderDetectedCloudDynamicHeight(containerId, keywords, isEnglish, sitePalette)
            } else {
                delay(100)
                val retryContainer = document.getElementById(containerId)
                if (retryContainer != null && retryContainer.clientHeight > 0) {
                    renderDetectedCloudDynamicHeight(containerId, keywords, isEnglish, sitePalette)
                }
            }
        }
    }
}

private fun renderDetectedCloudDynamicHeight(
    containerId: String,
    keywords: List<KeywordsUsageData>,
    isEnglish: Boolean,
    sitePalette: SitePalette
) {
    if (keywords.isEmpty()) return

    fun colorFor(cat: String): String = when (cat.lowercase()) {
        if (isEnglish) "fitness" else "atletico"    -> sitePalette.fitnessCategoryBorder.hex
        if (isEnglish) "mental" else "mentale"      -> sitePalette.mentalCategoryBorder.hex
        if (isEnglish) "technical" else "tecnica"   -> sitePalette.technicalCategoryBorder.hex
        if (isEnglish) "tactical" else "tattica"    -> sitePalette.tacticalCategoryBorder.hex
        if (isEnglish) "goalkeeper" else "portiere" -> sitePalette.goalKeeperCategoryBorder.hex
        else -> sitePalette.primary.hex
    }

    val sorted = keywords.sortedByDescending { it.usageCount }
    val minCount = keywords.minOfOrNull { it.usageCount }?.toDouble() ?: 1.0
    val maxCount = keywords.maxOfOrNull { it.usageCount }?.toDouble() ?: 1.0
    val minPx = 16
    val maxPx = 62

// Avoid division by zero / log(0)
    val logMin = ln(minCount.coerceAtLeast(1.0))
    val logMax = ln(maxCount.coerceAtLeast(1.0))
    val rangeLog = if (logMax > logMin) logMax - logMin else 1.0

    val wordsJson = sorted.joinToString(",", "[", "]") { kw ->
        val count = kw.usageCount.toDouble()
        val logCount = ln(count.coerceAtLeast(1.0))
        val fs = (minPx + (logCount - logMin) / rangeLog * (maxPx - minPx)).toInt()
        val color = colorFor(kw.keywordCategory)
        val safeText = kw.text.replace("'", "\\'")
        "{ text: '$safeText', size: $fs, count: ${kw.usageCount}, color: '$color' }"
    }


    val script = """
        (function() {
            var container = document.getElementById('$containerId');
            if (!container) return;
            var W = container.clientWidth;
            var H = container.clientHeight;
            if (W < 100 || H < 100) return;
            container.innerHTML = '';
 
            var words = $wordsJson;
 
            // Attempt 1: try fitting all words in the visible height
            // If d3 drops any, double the height and retry — repeat up to 4x
            function tryRender(svgH, attempt) {
                d3.layout.cloud()
                    .size([W, svgH])
                    .words(words.map(function(w) { return Object.assign({}, w); }))
                    .padding(4)
                    .rotate(function() { return Math.random() > 0.7 ? 90 : 0; })
                    .font("Inter, sans-serif")
                    .fontSize(function(d) { return d.size; })
                    .spiral("archimedean")
                    .on("end", function(placed) {
                        if (placed.length < words.length && attempt < 4) {
                            // Not all words placed — grow the canvas and retry
                            tryRender(svgH * 1.5, attempt + 1);
                            return;
                        }
 
                        // All words placed (or max attempts reached) — draw the SVG
                        container.innerHTML = '';
                        var svg = d3.select('#$containerId')
                            .append('svg')
                            .attr('width', W)
                            .attr('height', svgH);  // SVG may be taller than the container → scrolls
 
                        var g = svg.append('g')
                            .attr('transform', 'translate(' + W/2 + ',' + svgH/2 + ')');

                            // Remove any previous tooltip
                            var oldTooltip = document.querySelector('.word-cloud-tooltip');
                            if (oldTooltip) oldTooltip.remove();

                            var tooltip = document.createElement('div');
                            tooltip.className = 'word-cloud-tooltip';
                            tooltip.style.cssText = 'position:fixed;pointer-events:none;background:white;border:1px solid #eee;border-radius:6px;padding:4px 10px;font-size:12px;opacity:0;transition:opacity 0.15s;z-index:9999;';
                            document.body.appendChild(tooltip);
 
                        g.selectAll('text')
                            .data(placed)
                            .enter()
                            .append('text')
                            .style('font-size', function(d) { return d.size + 'px'; })
                            .style('font-family', 'Inter, sans-serif')
                            .style('font-weight', function(d) { return d.size > 36 ? '600' : d.size > 22 ? '500' : '400'; })
                            .style('fill', function(d) { return d.color; })
                            .style('cursor', 'default')
                            .style('opacity', 0)
                            .attr('text-anchor', 'middle')
                            .attr('transform', function(d) {
                                return 'translate(' + [d.x, d.y] + ')rotate(' + d.rotate + ')';
                            })
                            .text(function(d) { return d.text; })
                            .on('mouseover', function(event, d) {
                                d3.select(this).style('opacity', '1').style('cursor', 'pointer');
                                tooltip.style.opacity = '1';
                                tooltip.innerHTML = '<strong>' + d.text + '</strong> &nbsp;' + d.count;
                            })
                            .on('mousemove', function(event) {
                                tooltip.style.left = (event.clientX + 14) + 'px';
                                tooltip.style.top  = (event.clientY - 30) + 'px';
                            })
                            .on('mouseout', function() {
                                d3.select(this).style('opacity', '0.9').style('cursor', 'default');
                                tooltip.style.opacity = '0';
                            })
                            .transition()
                            .duration(500)
                            .delay(function(d, i) { return i * 15; })
                            .style('opacity', '0.9')    ;
                    })
                    .start();
            }
 
            tryRender(H, 0);
        })();
    """.trimIndent()

    kotlinx.browser.window.setTimeout({
        val el = kotlinx.browser.document.getElementById(containerId)
        if (el != null && el.clientHeight > 0) {
            js("eval(script)")
        } else {
            kotlinx.browser.window.setTimeout({
                val retryEl = kotlinx.browser.document.getElementById(containerId)
                if (retryEl != null && retryEl.clientHeight > 0) {
                    js("eval(script)")
                }
            }, 100)
        }
    }, 100)
}